<template>
  <div>
    <v-toolbar color="white" light app clipped-left>
      <v-toolbar-side-icon v-if="signedIn" @click.stop="drawer = !drawer" />
      <a href="/" class="no-text-deco">
        <v-toolbar-title v-if="signedIn && currentCompany">
          {{ !currentCompany.logoUrl ? currentCompany.name + ' IPS' : 'IPS' }}
        </v-toolbar-title>
        <v-toolbar-title v-else>
          IPS
        </v-toolbar-title>
      </a>
      <v-spacer />
      <img v-if="currentCompany && currentCompany.logoUrl" style="max-height:25px; margin-right:5px" :src="currentCompany.logoUrl">
      <v-spacer />
      <div v-if="signedIn">
        <v-btn icon href="/">
          <v-icon>fas fa-home</v-icon>
        </v-btn>

        <v-menu v-if="notificationAccess" v-model="notificationMenu" :close-on-content-click="false" :nudge-width="400" max-width="400" bottom left offset-y max-height="400">
          <v-btn slot="activator" icon>
            <v-badge color="secondary">
              <span v-if="notificationCount > 0" slot="badge">
                {{ notificationCount }}
              </span>
              <v-icon>
                far fa-bell
              </v-icon>
            </v-badge>
          </v-btn>

          <v-card>
            <div v-if="loadingNotifications" class="text-xs-center py-5">
              <v-progress-circular :size="70" :width="7" color="secondary" indeterminate />
            </div>
            <div v-if="!loadingNotifications && notificationObject.resultItems.length == 0" class="text-xs-center py-4">
              Looks like you are all caught up
            </div>
            <v-list v-if="!loadingNotifications && notificationObject.resultItems.length > 0" two-line dense>
              <v-list-tile v-for="notification in notificationObject.resultItems" :key="notification.id" class="" avatar @click="markNotificationAsRead(notification, true)">
                <v-list-tile-action>
                  <v-icon :color="notificationColor(notification)">
                    {{ notificationIcon(notification) }}
                  </v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ notification.title }}</v-list-tile-title>
                  <v-list-tile-sub-title>{{ notification.content }}</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-list-tile-action-text>{{ notification.dateTime | formatDateAgo }} <span v-if="!notification.read" class="unread" /></v-list-tile-action-text>
                  <v-menu bottom left @click.native.stop>
                    <v-icon slot="activator" small>
                      fas fa-ellipsis-h
                    </v-icon>
                    <v-list dense>
                      <v-list-tile v-if="!notification.read" @click="markNotificationAsRead(notification)">
                        <v-list-tile-title>Mark as Read</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="deleteNotification(notification)">
                        <v-list-tile-title class="red--text">
                          Remove Notification
                        </v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-menu>

        <v-menu v-if="companies.length > 0" offset-y bottom left fixed max-height="500">
          <v-btn slot="activator" icon>
            <v-icon>fas fa-network-wired</v-icon>
          </v-btn>
          <v-list>
            <v-subheader>Select a Company</v-subheader>
            <v-list-tile v-for="company in companies" :key="company.id" :href="`/UserCompany/SwitchCompany?companyId=${company.id}`" :disabled="currentCompany.id === company.id">
              <v-list-tile-title>{{ company.name }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>

        <v-menu offset-y bottom left max-height="500">
          <v-btn slot="activator" icon>
            <v-icon>far fa-user</v-icon>
          </v-btn>
          <v-list>
              <v-subheader>{{ user.fullName }}</v-subheader>
              <v-list-tile href="/Identity/Account/Manage">
                  <v-list-tile-title>Manage Account</v-list-tile-title>
              </v-list-tile>
              <v-list-tile href="/Support/Index" target="_blank">
                  <v-list-tile-title>Support</v-list-tile-title>
              </v-list-tile>
              <v-list-tile href="/Identity/Account/Logout">
                  <v-list-tile-title>Logout</v-list-tile-title>
              </v-list-tile>
          </v-list>
        </v-menu>
      </div>
      <div v-else href="/Account/Login" />
    </v-toolbar>

    <v-navigation-drawer v-model="drawer" temporary app clipped>
      <img v-if="currentCompany && currentCompany.logoUrl" class="img-fluid my-4 px-5" :src="currentCompany.logoUrl">
      <v-divider v-if="currentCompany && currentCompany.logoUrl" class="mb-0" />
      <v-list class="pt-0" dense>
        <v-list-group v-for="item in navItems" :key="item.id">
          <v-list-tile slot="activator" :key="item.id" avatar>
            <v-list-tile-avatar size="25" tile>
              <img :src="item.icon">
            </v-list-tile-avatar>
            <v-list-tile-title>{{ item.name }}</v-list-tile-title>
          </v-list-tile>

          <v-list-tile v-for="module in item.modules" :key="module.id" avatar :href="`/modules/${item.slug}/${module.slug}`">
            <v-list-tile-avatar size="15" tile style="justify-content: center;">
              <img :src="module.smallIcon">
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title>{{ module.name }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>

    <v-snackbar v-if="snackbarNotification" v-model="snackbar" bottom right auto-height :timeout="6000" :color="notificationColor(snackbarNotification)" @click="markNotificationAsRead(snackbarNotification)">
      {{ snackbarNotification.title }}
      <v-btn color="white" flat :href="snackbarNotification.actionUrl" @click="markNotificationAsRead(snackbarNotification)">
        Visit Url
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
  import axios from 'axios';
  import { HubConnectionBuilder, LogLevel } from '@aspnet/signalr';
  export default {
    parent: true,

    props: {
      homeTitle: {
        type: String,
        default: '',
      },

      signedIn: {
        type: Boolean,
        default: false,
      },

      currentCompany: {
        type: Object,
        default: () => { },
      },

      companies: {
        type: Array,
        default: () => [],
      },

      navItems: {
        type: Array,
        default: () => [],
      },

      propNotificationCount: {
        type: Number,
        default: 0,
      },
      notificationAccess: {
         type: Boolean,
         default: false
      }
    },

    data: () => ({
      drawer: false,
      superAdmin: window.superAdmin,
      user: window.user,
      notificationCount: 0,
      notificationMenu: false,
      loadingNotifications: false,
      notificationObject: {
        resultItems: [],
        pageSize: 10,
        currentPage: 1,
        totalRecords: 0,
      },
      snackbar: false,
      snackbarNotification: null,
      socketConnection: null,
    }),

    watch: {
      notificationMenu(val) {
        if (val) this.getNotifications();
      },
    },

    created() {
      this.setupSignalR();
      this.notificationCount = this.propNotificationCount;
    },

    mounted() {
      this.socketConnection.onclose(async () => {
        this.setupSignalR();
      });
      this.socketConnection.on('notification', (notification) => {
        this.triggerToast(notification);
      });
    },

    methods: {
      async getNotifications() {
        this.loadingNotifications = true;
            const { data } = await axios.get('/api/general/my-notifications');
        this.notificationObject = data;
        this.loadingNotifications = false;
        this.updateNotificationCount();
      },

      async markNotificationAsRead(notification, redirect = false) {
          await axios.get(`/api/general/my-notifications/${notification.id}/mark-read`);
        if (redirect) {
          window.location.href = notification.actionUrl;
        } else {
          await this.getNotifications();
        }
      },

      async deleteNotification(notification) {
          await axios.delete(`/api/general/my-notifications/${notification.id}`);
        await this.getNotifications();
      },

      async triggerToast(notification) {
        this.snackbarNotification = notification;
        this.snackbar = true;
        await this.updateNotificationCount();
      },

      async updateNotificationCount() {
          const { data } = await axios.get('/api/general/my-notifications/count');
        this.notificationCount = data;
      },

      notificationColor(notification) {
        switch (notification.typeDisplay) {
          case 'Information':
            return 'secondary';
          case 'Success':
            return 'green';
          case 'Warning':
            return 'orange';
          case 'Error':
            return 'red';
          case 'Critical':
            return 'red';
          default:
            return 'primary';
        }
      },

      notificationIcon(notification) {
        switch (notification.typeDisplay) {
          case 'Information':
            return 'fas fa-info-circle';
          case 'Success':
            return 'fas fa-check';
          case 'Warning':
            return 'fas fa-exclamation-circle';
          case 'Error':
            return 'fas fa-exclamation-circle';
          case 'Critical':
            return 'fas fa-times-circle';
          default:
            return '';
        }
      },

      setupSignalR() {
        this.socketConnection = new HubConnectionBuilder()
          .withUrl('/pushnotifications')
          .configureLogging(LogLevel.Error)
          .build();
        this.socketConnection
          .start()
          .catch(() => {
            setTimeout(() => this.setupSignalR(), 10000);
          });
      },
    },
  };
</script>

<style scoped>
  .v-snack--active {
    cursor: pointer;
  }

  .unread {
    height: 8px;
    width: 8px;
    background-color: blue;
    border-radius: 50%;
    display: inline-block;
    margin-left: 5px;
  }

  .v-list__tile__action {
    min-width: 40px;
  }
</style>